var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "w-100 h-100", attrs: { id: "login" } }, [
    _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c(
        "div",
        {
          staticClass:
            "content d-flex flex-column justify-content-center align-items-center",
          staticStyle: {
            width: "45%",
            "margin-top": "50px",
            transition: "1s all",
          },
        },
        [
          _c(
            "div",
            { staticClass: "content-form", staticStyle: { width: "60%" } },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                      "align-items": "center",
                    },
                  },
                  [_c("SupsisLogo"), _vm._v(" "), _c("language-switch")],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "50px",
                    color: "#183b56",
                    "font-weight": "700",
                    "font-size": "35px",
                  },
                },
                [
                  _c("div", { staticStyle: { "line-height": "1" } }, [
                    _vm._v(_vm._s(_vm.$t("login.passwordForget"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "40px" } }, [
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass: "font-weight-bold",
                      staticStyle: { color: "#183b56" },
                    },
                    [_vm._v(_vm._s(_vm.$t("login.email")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "3px" } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            "has-feedback": "",
                            "validate-status": _vm.loginForm.email
                              ? !!_vm.errors.first("email")
                                ? "error"
                                : "success"
                              : undefined,
                            help:
                              _vm.loginForm.email && _vm.errors.first("email")
                                ? _vm.$t("login.emailError")
                                : undefined,
                          },
                        },
                        [
                          _c(
                            "a-input",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'",
                                },
                              ],
                              ref: "userNameInput",
                              class: { error: !!_vm.errors.first("email") },
                              attrs: {
                                name: "email",
                                placeholder: _vm.$t("login.emailPlaceholder"),
                              },
                              model: {
                                value: _vm.loginForm.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.loginForm, "email", $$v)
                                },
                                expression: "loginForm.email",
                              },
                            },
                            [
                              _c("a-icon", {
                                attrs: { slot: "prefix", type: "mail" },
                                slot: "prefix",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex justify-content-between",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-100 text-center text-white font-weight-bold user-select-none",
                        staticStyle: {
                          "border-radius": "8px",
                          padding: "13px 0",
                          "font-size": "15px",
                        },
                        style: {
                          background: _vm.loginForm.email
                            ? "#ec4b1d"
                            : "#C3CAD9",
                          cursor: _vm.loginForm.email ? "pointer" : null,
                        },
                        on: {
                          click: function ($event) {
                            _vm.loginForm.email ? _vm.doForgetPassword() : null
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("login.passwordNew")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c("hr", { attrs: { color: "#C3CAD9", width: "50%" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { margin: "0px 5px", color: "#183b56" },
                        attrs: { width: "100%" },
                      },
                      [_vm._v(_vm._s(_vm.$t("login.loginAnd")))]
                    ),
                    _vm._v(" "),
                    _c("hr", { attrs: { color: "#C3CAD9", width: "50%" } }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex justify-content-between w-full",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "w-100 text-center text-white font-weight-bold",
                        staticStyle: {
                          background: "#183b56",
                          "border-radius": "8px",
                          padding: "13px 0",
                          "font-size": "15px",
                        },
                        attrs: { to: "/passwordless-login" },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("login.emailLogin")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex justify-content-between w-full",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "w-100 text-center text-white font-weight-bold",
                        staticStyle: {
                          background: "#183b56",
                          "border-radius": "8px",
                          padding: "13px 0",
                          "font-weight": "bold",
                        },
                        attrs: { to: "/login" },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("login.passwordAndLogin")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }